export default {
    signIn: 'Sign in',
    signUp: 'Sign up',
    signingIn: 'Signing in...',
    creatingAccount: 'Creating account...',
    signInFailed: 'Sign in failed',
    signUpFailed: 'Sign up failed',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    forgotPassword: 'Forgot password?',
    forgotPasswordTitle: 'Reset your password',
    forgotPasswordDescription: "Enter your email and we'll send you a reset link.",
    sendResetLink: 'Send reset link',
    sendingResetLink: 'Sending...',
    checkYourEmail: 'Check your email',
    resetLinkSent: 'If this email exists in our system, we sent you a reset link. Check your inbox.',
    resetPasswordTitle: 'Set a new password',
    resetPassword: 'Reset password',
    resettingPassword: 'Resetting...',
    passwordResetSuccess: 'Your password has been reset successfully.',
    invalidResetLink: 'This reset link is invalid or has expired.',
    requestNewLink: 'Request a new link',
    backToLogin: 'Back to login',
    form: {
        email: 'Email',
        password: 'Password',
        name: 'Name',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
    },
    validation: {
        emailInvalid: 'Please enter a valid email',
        passwordMinLength: 'Password must be at least 8 characters',
        nameMinLength: 'Name must be at least 2 characters',
        passwordsDoNotMatch: 'Passwords do not match',
    },
};
